import { useMemo } from 'react';
import { AviaLegTypes, GroundLegTypes } from '@/api/apis/route';
import { RouteSegmentType } from '@/types/route';
import { getSegmentMapKey } from '@/utils/route';
import { CaseLogisticsLeg } from './CaseLogisticsLeg';

type CaseLogisticsSegmentProps = {
  segment: RouteSegmentType;
  routeLegs: Map<string, (AviaLegTypes | GroundLegTypes)[]>;
};

export const CaseLogisticsSegment = ({ segment, routeLegs }: CaseLogisticsSegmentProps) => {
  const segmentsLegs = useMemo(() => routeLegs.get(getSegmentMapKey(segment)) || [], [segment, routeLegs]);

  return (
    <div className="flex flex-col pt-0.5" key={segment.id}>
      {segmentsLegs.map((leg, index, array) => {
        return (
          <CaseLogisticsLeg key={leg.id} segment={segment} leg={leg} showBottomConnector={array.length - 1 === index} />
        );
      })}
    </div>
  );
};
